import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_RECENTS_DASHBOARDS_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useRecents',
  name: 'Get Recents Dashboards',
  message: 'Fetch list of recents dashboards',
}
